/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { FormattedHTMLMessage } from 'react-intl';

const PopupModel = (props)=> {
  const {
    showModal,
    popupType,
    content,
    closeAction,
    confirmAction,
    backAction,
    disabled,
    classnames
  } = props;

  const closeActionHandler = ()=> {
    !disabled && closeAction && closeAction();
  };

  return (
    <Modal data-popupType={popupType} show={showModal} className={`rbb-modal ${classnames}`} onHide={closeActionHandler}>
        <Modal.Header closeButton>
          {content.title && <Modal.Title data-key={content.title && content.title.dataKey}>{content.title && content.title.text}</Modal.Title>}
        </Modal.Header>
        <Modal.Body>
          {content.info &&
            <p data-key={content.info && content.info.dataKey}>
              <FormattedHTMLMessage
                id={ content.info.dataKey }
                defaultMessage={ content.info.text }
              />
            </p>
          }
        </Modal.Body>
      {popupType === 'back' ?
        <Modal.Footer>
            <Button bsSize="large" disabled={disabled} onClick={backAction} data-key={content.backBtn.dataKey}>
              {content.backBtn.text}
            </Button>
            <Button bsStyle="primary" disabled={disabled}  onClick={confirmAction} data-key={content.confirmBtn.dataKey}>
              {content.confirmBtn.text}
            </Button>
        </Modal.Footer>
        :
        <Modal.Footer>
            <Button bsStyle="primary" bsSize="large" onClick={backAction} data-key={content.backBtn.dataKey}>
              {content.backBtn.text}
            </Button>
        </Modal.Footer>
      }
    </Modal>
  )
};

PopupModel.PropTypes = {
  closeAction: PropTypes.func,
  confirmAction: PropTypes.func,
  backAction: PropTypes.func,
  showModal: PropTypes.bool,
  content: PropTypes.object,
  popupType: PropTypes.string,
  disabled: PropTypes.bool,
  classnames: PropTypes.string
};

PopupModel.defaultProps = {
  content: {},
  popupType: 'back',
  disabled: false,
  classnames: ''
};

export default PopupModel


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/PopupModel/index.js